module.exports = __webpack_public_path__ + "assets/b8067a20807aa850efa24010c49616cc.png";